import { DeleteOutlined } from '@ant-design/icons';
import {
  Button, Col, Input, Row, Select, Tooltip,
} from 'antd';
import { WebengageMappingSourceType, webengageMappingSourceTypeOptions } from 'automations/data/actionNodes';
import { type SendWebengageEventNodeData } from 'automations/types/nodeSchemas/actionNodes';

import styles from './SendWebengageEventContent.module.scss';

type Mapping = SendWebengageEventNodeData['additionalOptions']['sendWebengageEvent']['mappings'][number];

export default function MappingRow({
  mapping,
  onChange,
  onRemove,
  leadAttributeOptions,
  leadAttributeOptionsLoading,
  activityAttributeOptions,
  activityAttributeOptionsLoading,
  activityAttributesAvailable,
}: {
  mapping: Partial<Mapping>;
  onChange: (patch: Partial<Mapping>) => void;
  onRemove?: () => void;
  leadAttributeOptions: { label: string; value: string }[];
  leadAttributeOptionsLoading: boolean;
  activityAttributeOptions: { label: string; value: string }[];
  activityAttributeOptionsLoading: boolean;
  activityAttributesAvailable: boolean;
}) {
  const isActivityAttribute = mapping.sourceType === WebengageMappingSourceType.LEAD_ACTIVITY_ATTRIBUTE;
  const isStatic = mapping.sourceType === WebengageMappingSourceType.STATIC;
  const sourceAttributeOptions = isActivityAttribute ? activityAttributeOptions : leadAttributeOptions;
  const sourceAttributeLoading = isActivityAttribute ? activityAttributeOptionsLoading : leadAttributeOptionsLoading;

  const sourceAttributeDisabledTitle = isActivityAttribute && !activityAttributesAvailable
    ? 'Lead Activity Attributes are available when this automation triggers off a single Activity '
      + '(e.g. Activity Created/Updated)'
    : undefined;

  return (
    <Row gutter={16} align="middle" className={styles.mappingRow}>
      <Col span={7}>
        <Input
          placeholder="WebEngage Attribute"
          value={mapping.webengageAttribute}
          onChange={(e) => onChange({ webengageAttribute: e.target.value })}
        />
      </Col>
      <Col span={6}>
        <Select
          className={styles.select}
          placeholder="Source Type"
          options={webengageMappingSourceTypeOptions}
          value={mapping.sourceType}
          onChange={(value) => onChange({ sourceType: value, sourceAttribute: '', sourceValue: '' })}
        />
      </Col>
      <Col span={7}>
        {isStatic ? (
          <Input
            placeholder="Value"
            value={mapping.sourceValue}
            onChange={(e) => onChange({ sourceValue: e.target.value })}
          />
        ) : (
          <Tooltip title={sourceAttributeDisabledTitle}>
            <Select
              className={styles.select}
              placeholder="Source Attribute"
              showSearch
              optionFilterProp="label"
              loading={sourceAttributeLoading}
              disabled={!mapping.sourceType || Boolean(sourceAttributeDisabledTitle)}
              options={sourceAttributeOptions}
              value={mapping.sourceAttribute || undefined}
              onChange={(value) => onChange({ sourceAttribute: value })}
            />
          </Tooltip>
        )}
      </Col>
      <Col span={4}>
        {onRemove && (
          <Button icon={<DeleteOutlined />} type="text" danger onClick={onRemove}>
            Remove
          </Button>
        )}
      </Col>
    </Row>
  );
}
